import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "./slices/headerSlices";
import mainSlice from "./slices/mainSlices";

const store = configureStore({
  reducer: {
    headerReducer: headerSlice,
    mainReducer: mainSlice,
  },
});

export default store;
